import { Button, type ButtonProps } from 'antd';
import type { FC, ReactNode } from 'react';
import styles from "./ActionButton.module.css"

interface ActionButtonProps {
  title?: ReactNode | string;
  icon?: ReactNode;
  onClick: NonNullable<ButtonProps['onClick']>;
  className?: string;
  size?: ButtonProps['size'];
  loading?: ButtonProps['loading'];
  isActive?: boolean;
  disabled?: boolean;
}

const ActionButton: FC<ActionButtonProps> = ({
  loading = false,
  title = '',
  onClick,
  size = 'middle',
  icon = null,
  className,
  isActive = false,
  disabled = false,
}) => {
  return (
    <Button
      size={size}
      loading={loading}
      type="primary"
      className={className || styles.wrapper}
      ghost={!isActive}
      onClick={onClick}
      icon={icon}
      disabled={disabled}
    >
      {title}
    </Button>
  );
};

export default ActionButton;
